import type { ReactNode } from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { SiteFooter } from '../components/SiteFooter';

// Wraps every route with the shared header. SiteHeader is position:fixed (sticky was
// unreliable on staging), so it's out of normal flow — the 76px spacer below reserves
// its height so page content isn't hidden under the bar. No wrapper <main> because
// each route already renders its own <main> (nesting <main> is invalid HTML).
export function AppLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <SiteHeader />
      <div style={{ height: 76 }} aria-hidden="true" />
      {children}
      <SiteFooter />
    </>
  );
}
